import { cn } from 'lib/cn';
import { type ComponentProps } from 'react';

export const Kbd = ({ className, ...props }: ComponentProps<'kbd'>) => (
  <kbd
    data-slot="kbd"
    className={cn(
      "bg-surface-secondary text-foreground in-data-[slot=tooltip-content]:bg-foreground-inverse/70 in-data-[slot=tooltip-content]:text-surface-inverse in-[.mantine-Tooltip-tooltip]:bg-foreground-inverse/70 in-[.mantine-Tooltip-tooltip]:text-surface-inverse pointer-events-none inline-flex h-5 w-fit min-w-5 items-center justify-center gap-1 rounded-sm px-1 font-sans text-xs font-medium select-none [&_svg:not([class*='size-'])]:size-3",
      className,
    )}
    {...props}
  />
);
Kbd.displayName = 'Kbd';

export const KbdGroup = ({ className, ...props }: ComponentProps<'div'>) => (
  <kbd
    data-slot="kbd-group"
    className={cn('inline-flex items-center gap-1', className)}
    {...props}
  />
);
KbdGroup.displayName = 'KbdGroup';
